/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Footer from "./../global/Footer";
import NavbarBottom from "./../global/NavbarBottom";
import CustomerStoriesFooter from "./CustomerStoriesFooter";
import CustomerStoriesCompanies from "./CustomerStoriesCompanies";
import tele from "../../assets/images/logos/customer/telecentras.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const CustomerStoriesContent = () => {
  const { t } = useTranslation();
  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="compliance">
        <div className="container-fuild background-customer-stories-image">
          <div className="container pt-50 pb-50">
            <div className="row">
              <div className="col-sm-10 col-sm-offset-1 text-center pt-50">
                <h2 className="font-weight-bold text-yellow font-48 pr-32">
                  {t("customer.title")}
                </h2>
                <p className="text-white">{t("customer.note1")}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container-fluid container-fluid--background"
          style={{ background: "#ffffff" }}
        >
          <div className="container features-page__container px-md-0">
            <div className="row pt-50">
              <div className="col-sm-6">
                <h2 className="heading font-weight-bold">
                  {t("customer.note2")}
                </h2>
                <h4>
                  {t("customer.note3")}
                  <br />
                  <br />
                  {t("customer.note4")}
                </h4>
                <Link
                  to="/customer-stories/telecenter"
                  className="btn-secondary"
                >
                  {t("customer.button")}
                </Link>
              </div>
              <div className="col-sm-6">
                <img
                  src={tele}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  width="400px"
                />
              </div>
            </div>
          </div>
        </div>

        <CustomerStoriesCompanies />

        <CustomerStoriesFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CustomerStoriesContent;
